// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__fa1n6","large":"styles_large__1qfRj"};